<h2 class="LeftPanelTitle">{{ "app.view.editor-edit-tools-view-component.edit" | translate }}</h2>
<sbb-accordion [multi]="false">
  <sbb-expansion-panel [expanded]="false" [hideToggle]="false" [disabled]="!getVariantIsWritable()">
    <sbb-expansion-panel-header>{{
      "app.view.editor-edit-tools-view-component.filterable-labels" | translate
    }}</sbb-expansion-panel-header>
    <sbb-accordion [multi]="false">
      <sbb-expansion-panel [expanded]="true">
        <sbb-expansion-panel-header>{{
          "app.view.editor-edit-tools-view-component.trainruns" | translate
        }}</sbb-expansion-panel-header>
        <sbb-label-drop-list-component
          [componentLabelRef]="'Trainrun'"
        ></sbb-label-drop-list-component>
      </sbb-expansion-panel>
      <sbb-expansion-panel [expanded]="false">
        <sbb-expansion-panel-header>{{
          "app.view.editor-edit-tools-view-component.nodes" | translate
        }}</sbb-expansion-panel-header>
        <sbb-label-drop-list-component [componentLabelRef]="'Node'"></sbb-label-drop-list-component>
      </sbb-expansion-panel>

      <sbb-expansion-panel [expanded]="false">
        <sbb-expansion-panel-header>{{
          "app.view.editor-edit-tools-view-component.notes" | translate
        }}</sbb-expansion-panel-header>
        <sbb-label-drop-list-component [componentLabelRef]="'Note'"></sbb-label-drop-list-component>
      </sbb-expansion-panel>
    </sbb-accordion>
  </sbb-expansion-panel>

  <sbb-expansion-panel
    [expanded]="getVariantIsWritable() && !getAreMultiObjectSelected()"
    [disabled]="!getVariantIsWritable()"
  >
    <sbb-expansion-panel-header>{{
      "app.view.editor-edit-tools-view-component.delete-netzgrafik-title" | translate
    }}</sbb-expansion-panel-header>

    <ng-container
      *ngIf="
        filterService.isAnyFilterActive() &&
        !filterService.isTemporaryDisableFilteringOfItemsInViewEnabled()
      "
    >
      <br />
      <sbb-label>{{
        "app.view.editor-edit-tools-view-component.non-visible-elements" | translate
      }}</sbb-label>
      <br />
      <button
        (click)="onClearAllFiltered()"
        [title]="
          'app.view.editor-edit-tools-view-component.delete-all-non-visible-elements-tooltip'
            | translate
        "
        class="TrainrunDialog EditorToolButton"
      >
        <sbb-icon svgIcon="bucket-foam-broom-small"></sbb-icon>
      </button>
      {{ "app.view.editor-edit-tools-view-component.delete-all-non-visible-elements" | translate }}
      <br />
    </ng-container>
    <br />
    <sbb-label>{{
      "app.view.editor-edit-tools-view-component.visible-elements" | translate
    }}</sbb-label>
    <br />
    <button
      (click)="onClearAllTrainruns()"
      [title]="
        'app.view.editor-edit-tools-view-component.delete-all-visible-trainruns-tooltip' | translate
      "
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="trash-small"></sbb-icon>
    </button>
    {{ "app.view.editor-edit-tools-view-component.delete-all-visible-trainruns" | translate }}
    <br />
    <button
      (click)="onClearAllNotes()"
      [title]="
        'app.view.editor-edit-tools-view-component.delete-all-visible-notes-tooltip' | translate
      "
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="trash-small"></sbb-icon>
    </button>
    {{ "app.view.editor-edit-tools-view-component.delete-all-visible-notes" | translate }}
    <br />
    <button
      (click)="onClear()"
      [title]="
        'app.view.editor-edit-tools-view-component.delete-all-visible-elements-tooltip' | translate
      "
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="trash-small"></sbb-icon>
    </button>
    {{ "app.view.editor-edit-tools-view-component.delete-all-visible-elements" | translate }}
  </sbb-expansion-panel>
  <sbb-expansion-panel [expanded]="false" [disabled]="!getVariantIsWritable()">
    <sbb-expansion-panel-header>
      {{ "app.view.editor-edit-tools-view-component.merge-netzgrafik-title" | translate }}
    </sbb-expansion-panel-header>
    <br />
    <button
      (click)="onLoadNetzgrafikToInsertCopyButton()"
      [title]="
        'app.view.editor-edit-tools-view-component.add-netzgrafik-as-copy-tooltip' | translate
      "
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="hierarchy-small"></sbb-icon>
    </button>
    {{ "app.view.editor-edit-tools-view-component.add-netzgrafik-as-copy" | translate }}
    <input
      hidden
      #netzgrafikMergeAsACopyFileInput
      type="file"
      accept=".json"
      (change)="onLoadNetzgrafikToMergeAsACopy($event)"
    />

    <br />
    <button
      (click)="onLoadNetzgrafikToMergeButton()"
      [title]="'app.view.editor-edit-tools-view-component.merge-netzgrafik-tooltip' | translate"
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="hierarchy-small"></sbb-icon>
    </button>
    {{ "app.view.editor-edit-tools-view-component.merge-netzgrafik" | translate }}
    <input
      hidden
      #netzgrafikMergeFileInput
      type="file"
      accept=".json"
      (change)="onLoadNetzgrafikToMerge($event)"
    />
  </sbb-expansion-panel>

  <sbb-expansion-panel [expanded]="false" [disabled]="!getVariantIsWritable()">
    <sbb-expansion-panel-header>
      {{ "app.view.editor-edit-tools-view-component.node-optimization-title" | translate }}
    </sbb-expansion-panel-header>
    <sbb-radio-group [(ngModel)]="activeOrderingAlgorithm" class="sbb-radio-group-vertical">
      <sbb-radio-button
        *ngFor="let option of orderingAlgorithmOptions"
        [value]="option.orderingAlgorithm"
        [title]="option.title | translate"
        (change)="onUpdateOrderingAlgorithm($event)"
      >
        {{ option.name | translate }}
      </sbb-radio-button>
    </sbb-radio-group>
  </sbb-expansion-panel>
  <sbb-expansion-panel [expanded]="false" [disabled]="!getVariantIsWritable()">
    <sbb-expansion-panel-header>
      {{
        "app.view.editor-edit-tools-view-component.node-optimization-disposition-title" | translate
      }}
    </sbb-expansion-panel-header>
    <br />
    <button
      (click)="onOptimizeLayout()"
      [title]="
        'app.view.editor-edit-tools-view-component.optimization-netzgrafik-tooltip' | translate
      "
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="arrow-start-right-small"></sbb-icon>
    </button>
    {{ "app.view.editor-edit-tools-view-component.optimize-layout" | translate }}
    <br />
    <button
      (click)="onInverseOptimizeLayout()"
      [title]="
        'app.view.editor-edit-tools-view-component.inverse_optimization-netzgrafik-tooltip'
          | translate
      "
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="arrow-end-right-small"></sbb-icon>
    </button>
    {{ "app.view.editor-edit-tools-view-component.inverse_optimization-netzgrafik" | translate }}
    <br />
  </sbb-expansion-panel>

  <sbb-expansion-panel *ngIf="getAreMultiObjectSelected()" [expanded]="getAreMultiObjectSelected()">
    <sbb-expansion-panel-header>
      <label style="color: #ec0000">
        {{
          "app.view.editor-edit-tools-view-component.align-elements-netzgrafik-title" | translate
        }}
      </label>
    </sbb-expansion-panel-header>
    <br />
    <button
      (click)="onAlignElementsLeft()"
      [title]="'app.view.editor-edit-tools-view-component.align-elements-left' | translate"
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="arrow-left-small"></sbb-icon>
    </button>
    {{ "app.view.editor-edit-tools-view-component.align-elements-left" | translate }}

    <br />
    <button
      (click)="onAlignElementsRight()"
      [title]="'app.view.editor-edit-tools-view-component.align-elements-right' | translate"
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="arrow-right-small"></sbb-icon>
    </button>
    {{ "app.view.editor-edit-tools-view-component.align-elements-right" | translate }}

    <br />
    <button
      (click)="onAlignElementsTop()"
      [title]="'app.view.editor-edit-tools-view-component.align-elements-top' | translate"
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="arrow-up-small"></sbb-icon>
    </button>
    {{ "app.view.editor-edit-tools-view-component.align-elements-top" | translate }}

    <br />
    <button
      (click)="onAlignElementsBottom()"
      [title]="'app.view.editor-edit-tools-view-component.align-elements-bottom' | translate"
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="arrow-down-small"></sbb-icon>
    </button>
    {{ "app.view.editor-edit-tools-view-component.align-elements-bottom" | translate }}
  </sbb-expansion-panel>
</sbb-accordion>
